import { LiveBrowserRenderer } from './classes.livebrowserrenderer.js';
import type { ILiveBrowserCanvasRendererOptions } from './interfaces.livebrowsercanvas.js';

/** JPEG/PNG canvas presentation with bounded input and frame delivery. */
export class LiveBrowserCanvasRenderer extends LiveBrowserRenderer {
  constructor(optionsArg: ILiveBrowserCanvasRendererOptions) {
    super(optionsArg);
  }
}
